import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const ReferralEngineScreen1: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        Track all referral activity on RQ. View every case, track key details,
        and see insights by relationship, service, and professional type.
      </p>
    }
  />
)

export default ReferralEngineScreen1
